<form [formGroup]="form">
    <mat-form-field>
        <mat-label>Course</mat-label>
        <input matInput type="text" placeholder="Course" formControlName="courseId" [matAutocomplete]="auto" required />
        <mat-autocomplete #auto="matAutocomplete" name="course" placeholder="Course" [displayWith]="displayCourseName">
            @for(course of filteredCourses | async; track course){
            <mat-option [value]="course">{{course.name}}</mat-option>
            }
            <hr />
            <div class="container-fluid">
                <div *ngIf="!addCourse" class="row align-items-baseline">
                    <div class="col">
                        <p>Don't see your course?</p>
                    </div>
                    <div class="col">
                        <button mat-stroked-button (click)="addCourseModal()">Add</button>
                    </div>
                </div>
            </div>
        </mat-autocomplete>
        <mat-error *ngIf="form.get('courseId').errors?.required">Course is required</mat-error>
        <mat-error *ngIf="form.get('courseId').errors?.validationErrors">
            {{ form.get("courseId").errors?.validationErrors}}
        </mat-error>
    </mat-form-field>
</form>